import React from 'react';
import { useParams } from 'react-router-dom';
import { CandlestickChart } from './index';

// Cache duration in milliseconds
export const CACHE_DURATION_MS = 10 * 60 * 1000; // 5 minutes

// Custom fetcher with persistence and cleanup
export const fetcher = async (url: string) => {
  // Cleanup expired data first
  const now = Date.now();
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith('stockdata/')) {
      try {
        const cached = localStorage.getItem(key);
        if (cached) {
          const { timestamp } = JSON.parse(cached);
          if (now - timestamp > CACHE_DURATION_MS) {
            localStorage.removeItem(key);
          }
        }
      } catch (error) {
        // If data is corrupted, remove it
        localStorage.removeItem(key);
      }
    }
  }

  // Try to get from localStorage
  const cached = localStorage.getItem(url);
  if (cached) {
    try {
      const { data, timestamp } = JSON.parse(cached);
      // If cache is less than CACHE_DURATION_MS old, return it
      if (now - timestamp < CACHE_DURATION_MS) {
        return data;
      }
      // If cache is old, remove it
      localStorage.removeItem(url);
    } catch (error) {
      // If data is corrupted, remove it
      localStorage.removeItem(url);
    }
  }
  return null;
};

export const CandlestickWithIsin: React.FC = () => {
  const { isin } = useParams<{ isin: string }>();
  return <CandlestickChart initialIsin={isin} />;
};

